import { FC } from 'react';
import { CaptionProps, useDayPicker, useNavigation } from 'react-day-picker';
import { Flex } from '@chakra-ui/react';

import IconButton from 'components/_core/IconButton';
import Text from 'components/_core/Text';
import { capitalize } from 'helpers/string';

import locales from './locales';

const Caption: FC<CaptionProps> = ({ displayMonth }): JSX.Element => {
  const { goToMonth, nextMonth, previousMonth } = useNavigation();

  const {
    formatters: { formatCaption },
    locale,
  } = useDayPicker();

  const goToPreviousMonth: React.MouseEventHandler = () => {
    if (!previousMonth) {
      return;
    }

    goToMonth(previousMonth);
  };

  const goToNextMonth: React.MouseEventHandler = () => {
    if (!nextMonth) {
      return;
    }

    goToMonth(nextMonth);
  };

  const caption = formatCaption(displayMonth, { locale });

  return (
    <Flex alignItems="center" justifyContent="space-between">
      <IconButton
        aria-label={locales.months.previous}
        icon="arrow-left"
        iconSize="icon-20"
        onClick={goToPreviousMonth}
        variant="inline-secondary"
      />

      <Text fontWeight="weight-500" variant="primary">
        {capitalize(String(caption))}
      </Text>

      <IconButton
        aria-label={locales.months.next}
        icon="arrow-right"
        iconSize="icon-20"
        onClick={goToNextMonth}
        variant="inline-secondary"
      />
    </Flex>
  );
};

export default Caption;
